export default "__VITE_ASSET__5f900899__"